import React from 'react';
import { translations } from '../translations';
import '../styles/components/KidProgressModal.css';

function KidProgressModal({ kid, details, language, onClose }) {
  const t = translations[language];

  const getCompletionIcon = (isCompleted) => {
    return isCompleted === true || isCompleted === 1 ? '✓' : '○';
  };

  const getCompletionClass = (isCompleted) => {
    return isCompleted === true || isCompleted === 1 ? 'completed' : 'incomplete';
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString(language === 'fr' ? 'fr-FR' : 'en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="kid-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <div className="kid-modal-info">
            <div className="kid-modal-avatar">
              {kid.avatar ? (
                <img src={kid.avatar} alt={kid.first_name} />
              ) : (
                <div className="avatar-placeholder-large">
                  {kid.first_name?.charAt(0)?.toUpperCase() || '?'}
                </div>
              )}
            </div>
            <h2>{kid.first_name} {kid.last_name}</h2>
          </div>
          
          <div className="coin-balance">
            <span className="coin-icon">🪙</span>
            <span className="coin-amount">
              {details?.coin_balance ?? '...'}
            </span>
          </div>
        </div>

        <div className="progress-section">
          <h3>{t.progress || 'Progress'}</h3>
          
          {!details ? (
            <div className="loading-progress">
              <div className="loading-spinner-small"></div>
              <p>{t.loadingProgress || 'Loading progress...'}</p>
            </div>
          ) : details.progress?.length === 0 ? (
            <div className="no-progress">
              <p>{t.noProgress || 'No progress data available'}</p>
            </div>
          ) : (
            <table className="progress-table">
              <thead>
                <tr>
                  <th>{t.levelName || 'Level'}</th>
                  <th>{t.score || 'Score'}</th>
                  <th>{t.status || 'Status'}</th>
                </tr>
              </thead>
              <tbody>
                {details.progress.map((level, index) => (
                  <tr key={index}>
                    <td>{`${t.levelName} ${level.level_id}`}</td>
                    <td>
                      {level.level_id === 4 ? level.score : '-'}
                    </td>
                    <td className={getCompletionClass(level.is_completed)}>
                      <div className="status-content">
                        <span className="status-icon">
                          {getCompletionIcon(level.is_completed)}
                        </span>
                        <span className="status-text">
                          {(level.is_completed === true || level.is_completed === 1)
                            ? (t.completed || 'Completed') 
                            : (t.inProgress || 'In Progress')}
                        </span>
                      </div>
                      {(level.is_completed === true || level.is_completed === 1) && level.completed_at && (
                        <div className="completed-date">
                          {formatDate(level.completed_at)}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default KidProgressModal;
